import { isAddress } from 'ethers/lib/utils';
import type { Address } from 'viem';

export const isValidEvmAddress = (address: string): address is Address => {
  return isAddress(address);
};
